export default __webpack_public_path__ + "static/media/under-construction.6a2d6e4d.svg";